import React from "react";
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import QuoteLarge from "../icons/QuoteLarge";
import { useHistory } from 'react-router-dom';
import Authorize from '../Authorize';
import * as Roles from '../../resources/UserRole';
import { useQuotesFilter } from '../../hooks/QuotesFilterContext';

export const ActiveQuotes = (props) => {
    const { clearFilters, updateFilter } = useQuotesFilter();
    const history = useHistory();
    const quoteData = props.quoteData; 

    const handleQuoteFilterClick = () => {
        clearFilters();
        const statuses = props.availableStatuses.filter(x => x.isQuoteStatus === true && x.shown === true && x.isActiveStatus === true).map(x => x.description);
        updateFilter('status', statuses);
        updateFilter('dateRange', props.QuoteDayRange);
        const query = {
            statuses: statuses.join(','),
            dateRange: props.QuoteDayRange
        };
        history.push({
            pathname: "/quotes",
            search: new URLSearchParams(query).toString()
        });
    };

    return (
        <>
            { props.storeSettings.settingsList.UseDashBoardActiveQuotes == "1" &&
                <Authorize hasRoles={[Roles.VIEW_QUOTE_HISTORY]} displayMessage={false}>
                    <div className="green-box">
                        <button 
                            style={{ all: 'unset', cursor: 'pointer' }}
                            onClick={handleQuoteFilterClick}
                        >
                            <div className="flex">
                                <div><QuoteLarge /></div>
                                <div className="big-number" style={{ padding: "10px"}}>
                                    <div className="font-size-64">
                                        {quoteData.totalOpenQuotes}
                                    </div>
                                    <div className="label-wrapper">
                                        <div className="font-size-28">
                                            {props.dashboardLabels.QUOTES}
                                        </div>
                                        <div className="font-size-20">
                                            {props.dashboardLabels.INPROGRESS}
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </button>
                    </div>
                </Authorize>
            }
        </>
    );
}

ActiveQuotes.propTypes = {
    quoteData: PropTypes.object,
    QuoteDayRange: PropTypes.string
};
function mapStateToProps(state) {
    return {
        selectedCustomer: state.user.selectedCustomer,
    };
}

export default connect(mapStateToProps, null)(ActiveQuotes);